module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/venetian-blind-window/veneziana.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/venetian-blind-window/veneziana.png
// module id = 493
// module chunks = 0